import { Worker } from '../shared/Worker'
import type { Color } from '../../types/game'

interface WorkerFlight {
  id: number
  color: Color
  startX: number
  startY: number
  deltaX: number
  deltaY: number
}

interface WorkerFlightOverlayProps {
  flights: WorkerFlight[]
}

export function WorkerFlightOverlay({ flights }: WorkerFlightOverlayProps) {
  if (flights.length === 0) {
    return null
  }

  console.debug('[worker-animation] overlay render', flights)

  return (
    <div className="worker-flight-overlay">
      {flights.map((flight) => (
        <div
          key={flight.id}
          className="worker-flight"
          style={{
            left: `${flight.startX}px`,
            top: `${flight.startY}px`,
            '--worker-flight-dx': `${flight.deltaX}px`,
            '--worker-flight-dy': `${flight.deltaY}px`,
          } as React.CSSProperties}
        >
          <Worker color={flight.color} size="1.4em" />
        </div>
      ))}
    </div>
  )
}
